import React from 'react';

import constants from '../../utils/constants';

const OptimizeTest = () => {
  const { KabbageSimple } = constants;

  return (
    <section className="optimize-test">
      <div className="arrow-down" />
      <div className="container minimum-qual homepage">
        <div className="two-column main-two">
          <div className="column minimum">
            <h2 className="h1-style">Minimum qualification requirements</h2>
            <p>
              To qualify with <KabbageSimple />, you should be in business for
              at least one year and have a minimum of $50,000 in annual revenue
              or $4,200 per month over the last three months.<sup>1</sup>
            </p>
            <span>› Applying is Free</span>
            <span>› No Obligation to Take Funds</span>
          </div>
          <div className="column right-row">
            <div className="two-column top-row">
              <div className="column left">
                Years in
                <br /> Business
              </div>
              <div className="column right year">1 year +</div>
            </div>
            <div className="two-column bottom-row">
              <div className="column left">
                Business
                <br /> Revenue
              </div>
              <div className="column right money">
                $50,000 Annually
                <br />
                - or -
                <br />
                $4,200 / Month
                <br />
                <span>over the last 3 months</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OptimizeTest;
